import { AccountOperParams } from '@lk/api/account/models'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const accountOperAccessPermAdd = createAsyncThunk<any, Partial<AccountOperParams>, ThunkApi>(
  '[ACCOUNT_OPER] ACCESS_PERM_ADD',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.oper('accesspermadd', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const accountOperAccessPermDelete = createAsyncThunk<any, Partial<AccountOperParams>, ThunkApi>(
  '[ACCOUNT_OPER] ACCESS_PERM_DELETE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.oper('accesspermdelete', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)
